module.exports = __webpack_public_path__ + "static/media/logo_bdan.8e13a815.png";